import { isArray, isObject, isPlainObject } from 'lodash';

/**
 * Recursively traverses the given source object/array and replaces all keys
 * named 'find' with the string 'replace'. This is useful for replacing keys
 * in deeply nested objects.
 *
 * @param {string} find - The key to find and replace
 * @param {string} replace - The new name for the key
 * @param {object|array} source - The object or array to traverse
 * @returns {object|array} The transformed object or array
 */
export function recursiveKeyReplacement(find, replace, source) {
    if (isArray(source)) {
        return source.map((item) => recursiveKeyReplacement(find, replace, item));
    }
    if (!isPlainObject(source)) {
        return source;
    }

    const target = {};
    for (let key in source) {
        if (key === find) {
            target[replace] = recursiveKeyReplacement(find, replace, source[find]);
        } else {
            target[key] = recursiveKeyReplacement(find, replace, source[key]);
        }
    }
    return target;
}
